<div class="disable-confirm-container">
  <div class="dialog-header">
    <p class="disable-confirm-title alt-inter-bold alt-size-20">
      {{"FACILITATOR.select-allied" | translate }}
    </p>
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <p class="disable-confirm-text-one alt-size-14 alt-inter-semibold">
    {{"FACILITATOR.transfer-indicatinos" | translate}}
  </p>

  <form #chooseAllied="ngForm" class="input-format" (ngSubmit)="save(chooseAllied)">
    <mat-form-field class="form-field margin-field1" appearance="outline">
      <mat-label class="alt-inter-medium alt-size-16">
        {{"USERS.orga" | translate}}
      </mat-label>
      <mat-select matInput ngModel name="organization" required>
        <mat-option *ngFor="let organization of organizationList" [value]="organization">
          <p>{{organization.name_ally}}</p>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button type="submit" mat-button class="create-button" 
      [class.disbale-btn]="chooseAllied.invalid" 
      [disabled]="chooseAllied.invalid">
      {{"FACILITATOR.choose" | translate | uppercase}}
    </button>
  </form>
</div>
